import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

function BasicTooltip({ children, title }: BasicTooltipProps) {
  return <Tooltip title={title}>{children}</Tooltip>;
}

export default BasicTooltip;
